import { StoreDeliveryFeeType } from 'types/storeDeliveryFee'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchStoreDeliveryFees } from 'reducks/storeDeliveryFee/operations'
import { State } from 'index'
import { getStoreDeliveryFees } from 'reducks/storeDeliveryFee/selectors'
import { getStoreRef } from 'reducks/auth/selectors'

const useFetchDeliveryFees = (): StoreDeliveryFeeType[] => {
  const dispatch = useDispatch()
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const storeDeliveryFees = useSelector((state: State) => getStoreDeliveryFees(state))
  useEffect(() => {
    if (!storeRef || storeDeliveryFees.length > 0) return
    dispatch(fetchStoreDeliveryFees(storeRef))
  }, [storeRef])
  return storeDeliveryFees
}

export default useFetchDeliveryFees
